import React from "react";
import PropTypes from "prop-types";
import Popup from "reactjs-popup";
import "./DestructiveConfirmModal.css";

const OVERLAY_STYLE = { background: "rgba(10,13,18,0.7)", backdropFilter: "blur(8px)" };

const CONTENT_STYLE = {
  border: "none",
  borderRadius: "var(--sl-radius-xl, 12px)",
  padding: "24px",
  width: "min(400px, calc(100vw - 40px))",
  background: "var(--sl-bg-primary)",
  boxShadow: "var(--sl-shadow-lg, 0 20px 24px -4px rgba(10,13,18,0.08), 0 8px 8px -4px rgba(10,13,18,0.03))",
  textAlign: "left",
};

const DestructiveConfirmModal = ({ trigger, open, onClose, title, body, confirmLabel, cancelLabel, onConfirm, icon }) => {
  const controlled = {};
  if (open !== undefined) controlled.open = open;
  if (onClose) controlled.onClose = onClose;

  return (
  <Popup
    modal
    trigger={trigger || undefined}
    overlayStyle={OVERLAY_STYLE}
    contentStyle={CONTENT_STYLE}
    closeOnDocumentClick
    {...controlled}
  >
    {(close) => (
      <div className="destructive-confirm" data-testid="destructive-confirm">
        <span className="destructive-confirm-icon"><i className={icon} /></span>
        <h2 className="destructive-confirm-title">{title}</h2>
        <div className="destructive-confirm-body">{body}</div>
        <div className="destructive-confirm-actions">
          <button type="button" className="destructive-confirm-cancel" onClick={close} data-testid="destructive-cancel">{cancelLabel}</button>
          <button type="button" className="destructive-confirm-delete" onClick={() => { close(); onConfirm(); }} data-testid="destructive-confirm-btn">{confirmLabel}</button>
        </div>
      </div>
    )}
  </Popup>
  );
};

DestructiveConfirmModal.propTypes = {
  trigger: PropTypes.element,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string.isRequired,
  body: PropTypes.node.isRequired,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  icon: PropTypes.string,
};

DestructiveConfirmModal.defaultProps = {
  trigger: null,
  open: undefined,
  onClose: null,
  confirmLabel: "Delete",
  cancelLabel: "Cancel",
  icon: "far fa-trash-alt",
};

export default DestructiveConfirmModal;
